// Paint-tracking API helpers (read-only surface — writes happen on the mobile
// scanner). Uses the shared apiClient so it picks up auth + Live/Test mode
// automatically.

import api from "@/lib/apiClient";

export const paintApi = {
  /** Live paint queue + urgency thresholds. */
  queue: () => api.get("/paint/queue").then((r) => r.data),

  /** List batches (optionally filtered by status). */
  batches: (status) =>
    api
      .get("/paint/batches", { params: status ? { status } : {} })
      .then((r) => r.data),

  /** One batch with enriched order_number / customer_name per item. */
  getBatch: (id) => api.get(`/paint/batches/${id}`).then((r) => r.data),

  /** Urgency thresholds (green_days / yellow_days). */
  settings: () => api.get("/paint/settings").then((r) => r.data),
};

/** Classify a days-out value against thresholds. */
export function paintUrgency(daysOut, thresholds) {
  const d = Number(daysOut) || 0;
  const g = Number(thresholds?.green_days) ?? 3;
  const y = Number(thresholds?.yellow_days) ?? 7;
  if (d <= g) return "green";
  if (d <= y) return "yellow";
  return "red";
}

/** Currently at painter for an item (never negative). */
export function unitsAtPainter(item) {
  if (!item) return 0;
  const out = Number(item.paint_units_out) || 0;
  const back = Number(item.paint_units_returned) || 0;
  return Math.max(0, out - back);
}
